module.exports = __webpack_public_path__ + "assets/all_data_black.363b1f96.svg";